import React from 'react';

const Team = () => {
  const founders = [
    {
      name: 'Rajesh Kumar',
      role: 'Founder',
      qualification: 'Graduate',
      experience: 'More than 25 years',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/hp2q2kap_WhatsApp%20Image%202026-03-21%20at%2012.41.19%20PM.jpeg',
      description: 'Visionary leader with over 25 years of extensive experience in interior design and project management. Rajesh has successfully led numerous high-profile commercial and residential projects, bringing innovative design solutions and impeccable execution to every assignment. His deep understanding of client needs and commitment to quality has established Classic Decor as a trusted name in the industry.'
    },
    {
      name: 'Vijay Krishna Mani',
      role: 'Co-Founder',
      qualification: 'B-Tech Civil',
      experience: '17 years',
      image: 'https://customer-assets.emergentagent.com/job_design-portfolio-321/artifacts/ztmn0qjd_WhatsApp%20Image%202026-03-21%20at%201.36.00%20PM.jpeg',
      description: 'Technical expert with 17 years of experience specializing in structural design and civil engineering solutions. Vijay brings strong technical expertise in project planning, execution, and quality control. His engineering background ensures that every Classic Decor project meets the highest standards of structural integrity and functional excellence, seamlessly blending aesthetics with engineering precision.'
    }
  ];

  const teamMembers = [
    {
      name: 'Manish Sharma',
      role: 'Coordinator',
      image: 'https://customer-assets.emergentagent.com/job_a4af5be8-2035-4ca3-9ea9-364fcf5ee959/artifacts/8ycszfl4_WhatsApp%20Image%202026-03-23%20at%2010.41.08%20PM.jpeg',
      description: 'A key member since the company was formed, Manish has been instrumental in coordinating operations and ensuring seamless communication between teams and clients for smooth project execution.'
    },
    {
      name: 'Subash',
      role: 'Project Manager',
      image: null,
      description: 'Experienced project manager overseeing on-site execution and ensuring timely delivery of all Classic Decor projects.'
    }
  ];

  return (
    <section id="team" className="py-24 px-6 bg-[#111113]" data-testid="team-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-[#FF8C42] text-sm tracking-[0.3em] uppercase mb-4">Our Team</p>
          <h2
            className="text-4xl md:text-5xl font-serif text-white mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Meet Our Team
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            The creative minds behind Classic Decor's success
          </p>
        </div>

        {/* Founders Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto mb-16">
          {founders.map((member, index) => (
            <div
              key={index}
              className="group relative bg-[#1a1a1c] rounded-sm overflow-hidden hover:shadow-2xl hover:shadow-[#FF8C42]/10 transition-all duration-500"
              data-testid={`founder-card-${index}`}
            >
              <div className="relative h-96 overflow-hidden bg-[#0a0a0c]">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1c] via-transparent to-transparent" />
              </div>
              <div className="p-8">
                <h3
                  className="text-2xl font-serif text-white mb-2 group-hover:text-[#FF8C42] transition-colors"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {member.name}
                </h3>
                <p className="text-[#FF8C42] text-sm mb-1">{member.role}</p>
                <p className="text-white/50 text-sm mb-2">{member.qualification}</p>
                <p className="text-[#FF8C42] font-medium text-sm mb-4">
                  Experience: {member.experience}
                </p>
                <p className="text-white/70 leading-relaxed text-sm">{member.description}</p>
              </div>
              <div className="absolute inset-0 border border-[#FF8C42]/0 group-hover:border-[#FF8C42]/30 transition-all duration-500 pointer-events-none" />
            </div>
          ))}
        </div>

        {/* Team Members */}
        <div className="text-center mb-12">
          <h3
            className="text-2xl font-serif text-white"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Our Key Members
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group bg-[#1a1a1c] rounded-sm overflow-hidden hover:shadow-2xl hover:shadow-[#FF8C42]/10 transition-all duration-500 flex items-center p-6 gap-6"
              data-testid={`team-member-card-${index}`}
            >
              <div className="w-24 h-24 flex-shrink-0 rounded-full overflow-hidden bg-[#0a0a0c]">
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-[#FF8C42] text-2xl font-serif" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {member.name.charAt(0)}
                  </div>
                )}
              </div>
              <div>
                <h4
                  className="text-lg font-serif text-white group-hover:text-[#FF8C42] transition-colors"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {member.name}
                </h4>
                <p className="text-[#FF8C42] text-sm mb-2">{member.role}</p>
                <p className="text-white/70 text-sm leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
